import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import noop from 'lodash/noop';
import buttonTypes from './buttonPropTypes';
import styles from './Button.module.scss';

const colorClasses = {
  primary: styles['button-primary'],
  secondary: styles['button-secondary'],
  tertiary: styles['button-tertiary'],
  transparent: styles['button-transparent'],
};

const variantClasses = {
  small: styles['button-small'],
};

export default function Button(props) {
  const {
    className,
    children,
    disabled,
    selected,
    color,
    variant,
    onClick,
    type,
    ...otherProps
  } = props;

  const click = (e) => {
    if (onClick && !disabled) {
      onClick(e);
    }
  };

  return (
    <button
      className={classnames(
        styles.button,
        {
          [styles.disabled]: disabled,
          [styles['button-selected']]: selected,
        },
        colorClasses[color],
        variantClasses[variant],
        className,
      )}
      onClick={click}
      type={type}
      disabled={disabled}
      {...otherProps}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  /**
   * contents of the button
   */
  children: PropTypes.node,
  /**
   * Disabled state, passed straight to underlying `button` element
   */
  disabled: PropTypes.bool,
  /**
   * Selected state, used by toggle and dropdown buttons
   */
  selected: PropTypes.bool,
  /**
   * Function to run `onClick`
   */
  onClick: PropTypes.func,
  /**
   * Class name for the `button`
   */
  className: PropTypes.string,
  /**
   * HTML `button` `type` attribute
   */
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  /**
   * Button colors for emphasis
   */
  color: buttonTypes.color,
  /**
   * Button size/layout variants
   */
  variant: buttonTypes.variant,
};

Button.defaultProps = {
  children: null,
  disabled: false,
  selected: false,
  onClick: noop,
  className: '',
  type: 'button',
  color: 'default',
  variant: 'default',
};

Button.displayName = 'Button';
